import SummaryItem from "./SummaryItem";

export default SummaryItem;
